/**
 * Local (browser time zone) date helpers. `toISOString()` is UTC, so slicing it gives the wrong
 * day for evening times and the wrong hour in `<input type="datetime-local">`.
 */

const pad = (n) => String(n).padStart(2, '0');

function asDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value.toDate === 'function') return value.toDate();
  if (typeof value._seconds === 'number') return new Date(value._seconds * 1000);
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** 'YYYY-MM-DD' for the local calendar day, or '' when the value isn't a date. */
export function localDateKey(value) {
  const d = asDate(value);
  if (!d) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** 'YYYY-MM-DDTHH:mm' in local time for a datetime-local input, or '' when the value isn't a date. */
export function toDateTimeLocalValue(value) {
  const d = asDate(value);
  if (!d) return '';
  return `${localDateKey(d)}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
